import React from "react";
import PredictionPage from "../../components/PredictionPage";

function USDJPY() {
  return (
    <PredictionPage
      title="USDJPY"
      content="This is the USDJPY AI Trading Predictions page."
      canonical="/forex-majors/usdjpy-ai-trading-predictions"
      categoryKey="nav.forexMajors"
      categoryPath="/forex-majors"
      symbol="USDJPY"
    />
  );
}

export default USDJPY;
